<template>
  <div class="order-confirmation">
    <!-- <MainBackButton /> -->
    <p
      class="title is-4 has-text-link has-text-left"
      style="padding-top: 15px; margin-bottom: 2px"
    >
      <!-- <span style="padding-left:70px">{{ $t("delivery.order-confirmation") }}</span> -->
      <img
        src="../../public/img/icons/round-96x96.png"
        style="height: 45px; margin-left: 10px; margin-top: -6px"
        @click="goHome"
      />
      <span style="position: relative; top: -15px; padding-left: 10px">{{
        $t("delivery.order-confirmation")
      }}</span>
      <span
        class="button icon is-medium is-pulled-right is-link is-outlined"
        style="margin-right: 12px; margin-top: -5px; height: 32px; padding: 4px"
        @click="goHome"
      >
        <i class="fa fa-home" />
      </span>
    </p>

    <div class="container">
      <div class="notification" style="padding-top: 0">
        <!-- Business Type and Name (also address) -->
        <div class="field tags has-addons" v-if="businessName">
          <span class="single-line" style="padding-bottom: 10px">
            <span class="tag is-info is-medium">
              <i class="fa fa-store-alt" />
              &nbsp;{{ translateCategory(businessType) }}
            </span>
            <span
              class="tag is-white is-medium has-text-link has-text-weight-medium"
            >
              <a :href="businessMap" target="_blank">{{ businessName }}</a
              >&nbsp;
            </span>
          </span>
        </div>

        <div style="white-space: nowrap; overflow: hidden; width: 100vw">
          <span class="field tags has-addons">
            <span class="single-line" style="padding-bottom: 10px">
              <span class="tag is-warning is-medium">
                <i class="fa fa-phone" />
                &nbsp;
                {{ $t("delivery.your-mobile") }}
              </span>
              <span class="tag is-white is-medium has-text-weight-medium">{{
                phoneNumber
              }}</span>
            </span>
            <span
              class="tag has-text-danger is-pulled-right is-medium"
              @click="incorrectPhoneNumber"
              >{{ $t("delivery.incorrect") }}</span
            >
          </span>
        </div>

        <div class="field">
          <div class="control">
            <button
              class="button is-success is-fullwidth is-rounded"
              @click="preSubmit"
              :disabled="!hasAddress"
            >
              {{ $t("submit-address") }}
            </button>
          </div>
        </div>

        <div class="field address-field" @click="submitOK = true">
          <label class="label has-text-link" @click="useCoords"
            >{{ $t("delivery.delivering-to") }}...</label
          >
          <div class="control has-icons-left address" @click="initGoogle">
            <span class="icon is-small is-left" @click="useCoords">
              <i class="fas fa-map-marker-alt" />
            </span>
            <input
              id="delivery-dispatch-google"
              class="input is-info"
              type="text"
              ref="autocomplete"
              onfocus="value = ''"
              :placeholder="deliveryAddressPlaceholder"
            />
          </div>
        </div>

        <div class="map-wrapper" @click="scrollToBottom">
          <div id="delivering-to-map" class="map">
            <div v-if="fullAddress" class="leaflet-bottom" style="width: 100%">
              <span
                class="tag is-white has-text-success has-text-weight-medium"
                style="
                  opacity: 0.9;
                  padding: 6px;
                  margin: 5px;
                  box-shadow: 1px 1px 1px grey;
                  pointer-events: auto;
                "
                @click="$swal(fullAddress)"
                >{{ fullAddress }}</span
              >
            </div>
          </div>
        </div>

        <label class="label has-text-link">{{
          $t("delivery.location-notes")
        }}</label>
        <div class="field">
          <div class="control">
            <textarea
              class="textarea is-primary"
              v-model="notes"
              :placeholder="locationNotesPlaceholder"
              rows="1"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus";
import $Scriptjs from "scriptjs";
// import MainBackButton from "@/components/MainBackButton.vue";
import geo from "@/geo";
import L from "leaflet";
import "leaflet.locatecontrol";
// import "leaflet-edgebuffer";
import "leaflet.awesome-markers";

export default {
  name: "OrderConfirmation",
  components: {
    // MainBackButton
  },
  data() {
    return {
      uniqueMapID: "delivering-to-map",
      phoneNumber: "unknown",
      createdBy: "",
      map: undefined,
      marker: undefined,
      locateControl: undefined,
      active: false,
      delay: true,
      addressName: null,
      fullAddress: null,
      notes: null,
      price: null,
      // promptPay: null,
      paymentMethod: null,
      paymentID: null,
      businessType: null,
      businessName: null,
      businessLat: null,
      businessLon: null,
      country: null,
      submitOK: false, // change to true if user interacts with address
    };
  },
  computed: {
    businessMap() {
      if (!this.businessLat) return null;
      var lat = this.businessLat;
      var lon = this.businessLon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    deliveryAddressPlaceholder() {
      return this.$t("delivery.your-delivery-address");
    },
    locationNotesPlaceholder() {
      return this.$t("delivery.location-notes-placeholder");
    },
    hasAddress() {
      // return true if address is unknown, means we don't know your location
      // and you've not entered anything
      // !this.addressName
      return this.addressName || this.submitOK; //
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  mounted() {
    this.initMap();
    this.phoneNumber = this.$route.params.id; // required parameter
    var query = this.$route.query;
    this.createdBy = query.created_by; // optional to send push notification back to creator
    this.price = query.price;
    this.next = query.next;
    // this.promptPay = query.prompt_pay;
    this.paymentMethod = query.payment_method;
    this.paymentID = query.payment_id;
    this.businessType = query.business_type;
    this.businessName = query.business_name;
    this.businessLat = parseFloat(query.lat);
    this.businessLon = parseFloat(query.lon);
    this.country = query.country;
    this.console(`order confirmation phone_number: ${this.phoneNumber}`);
    this.checkForDeliveryAddress(); // check if user already has a delivery address

    var googlePlacesURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(googlePlacesURL, () => this.initGoogle());
  },
  activated() {
    // not used yet, use it to compute distance and therefore delivery price
    this.pickup = {
      id: "special_stop",
      name: this.businessName,
      lat: this.businessLat,
      lon: this.businessLon,
    };
  },
  methods: {
    useCoords() {
      this.$swal({
        title: `Paste Coordinates`,
        html: `For business super users 🤫`,
        input: "text",
        inputPlaceholder: "18.8983027,99.0111249",
        confirmButtonText: this.$t("submit"),
        cancelButtonText: "Oops, not a super user",
        showCancelButton: true,
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("info"),
        inputValidator: (txt) => {
          if (!txt || txt.length < 6 || txt.indexOf(",") === -1)
            return "Enter latitude,longitude";
        },
      }).then((val) => {
        if (val.value) {
          var latString = val.value.split(",")[0];
          var lonString = val.value.split(",")[1];
          var lat = parseFloat(latString);
          var lon = parseFloat(lonString);
          if (!lat || !lon) {
            var msg = `Incorrect format [ ${val.value} ] please enter latitude,longitude with no spaces.`;
            alert(msg);
          }
          this.updateMarkerLocation({ lat: lat, lon: lon });
        }
      });
    },
    checkForDeliveryAddress() {
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("getUserAddress", this.phoneNumber)
        .then((res) => {
          console.log("getUserAddress", res);
          this.setPastDeliveryAddress(res.data);
          this.addressName = res.data.name;
          this.fullAddress = res.data.address;
          var warning = this.bulmaColor("warning");
          var text = this.$t("delivery.previous-address-text");
          var previous = this.$t("delivery.previous-address");
          this.$swal({
            title: this.$t("delivery.previous-address-title") + "🥳",
            html: `${text} 🙌🏽<br><br>
          <div style='text-align:left'>
          <button style='background-color:${warning}; font-size:0.8em'>
          ${previous}</button><br><i><strong>${this.addressName}</strong><br>
          <span style='font-size:0.8em'>${this.fullAddress}</span></i></div>`,
            showCancelButton: true,
            confirmButtonText: this.$t("delivery.yes-deliver"),
            cancelButtonText: this.$t("delivery.change-address"),
            confirmButtonColor: this.bulmaColor("success"),
            cancelButtonColor: this.bulmaColor("info"),
          }).then((val) => {
            if (val.value) this.submit();
          });
        })
        .catch((err) => {
          console.error(err);
          this.locateControl.start(); // go to current location if no delivery address exists
        })
        .finally(() => loader.hide());
    },
    setPastDeliveryAddress(data) {
      this.updateMarkerLocation({ lat: data.lat, lon: data.lon });
      this.notes = data.notes;
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps
      var bangkokCoords = [13.73114, 100.57529]; // soi 41
      var initialLocation = this.$store.getters.getUserLocation;
      if (!initialLocation) initialLocation = bangkokCoords;

      this.map = L.map(this.uniqueMapID, {
        attributionControl: false,
        zoomControl: true,
      });
      this.map.setView(
        initialLocation,
        17 // set zoom level
      );

      L.tileLayer(tilesURL, {
        // edgeBufferTiles: 1,
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 12,
        maxZoom: 19,
      }).addTo(this.map);
      this.map.invalidateSize();

      var icon = L.AwesomeMarkers.icon({
        icon: "street-view",
        markerColor: "green",
      });
      var iconDrag = L.AwesomeMarkers.icon({
        icon: "crosshairs",
        markerColor: "green",
        spin: true,
      });

      this.marker = L.marker(initialLocation, { icon: icon }).addTo(this.map);
      this.marker.normalIcon = icon;
      this.marker.dragIcon = iconDrag;
      var opts = { closeButton: false, autoPan: false };
      this.marker.bindPopup(this.$t("delivery.delivery-location"), opts);
      this.map.on("move", () => {
        // if (!this.map || !this.marker || !this.active || this.delay) return;
        this.marker.setLatLng(this.map.getCenter());
        this.scrollToBottom();
      });
      this.map.on("dragstart", () => {
        this.marker.setIcon(this.marker.dragIcon);
        this.marker.closePopup();
      });
      this.map.on("moveend", () => {
        // if (!this.map || !this.marker || !this.active) return;
        this.marker.setLatLng(this.map.getCenter()); // needed?
        this.marker.center = this.map.getCenter();
        this.marker.openPopup();
        this.marker.setIcon(this.marker.normalIcon);
      });
      this.setupLocateControl();
    },
    setupLocateControl() {
      var clickBehavior = {
        inView: "setView",
        outOfView: "inView", //"setView",
        inViewNotFollowing: "inView",
      };
      var options = {
        position: "topright",
        icon: "fa fa-crosshairs",
        enableHighAccuracy: true,
        keepCurrentZoomLevel: true,
        flyTo: true,
        showPopup: true,
        drawCircle: false,
        drawMarker: true, // false for driver only
        showCompass: true, // false for driver only
        clickBehavior: clickBehavior,
        onLocationError: (err) => console.warn("locateControl", err),
      };
      this.locateControl = L.control.locate(options).addTo(this.map);
      // this.locateControl.start(); // centers map to user geolocation
    },
    preSubmit() {
      // check distance to user and other checks
      var coords = this.$store.getters.getUserLocation;
      var userLoc = { lat: coords[0], lon: coords[1] };
      var dropoff = this.marker.getLatLng();
      var dist = geo.distanceToUserInMeters(dropoff, userLoc);
      if (dist < 500 || !coords || dist > 900000) return this.submit();
      // else double check
      this.$swal({
        html: `You seem far away from the delivery address, are you sure it's correct?<br><br>
        ${this.addressName} is ${dist} meters from your current location.`,
        confirmButtonText: "Yes, that's right",
        cancelButtonText: this.$t("try-again"),
        showCancelButton: true,
      }).then((val) => {
        if (val.value) this.submit();
      });
    },
    submit() {
      // prompt user for geolocation at beginning
      // in app.vue skip certain checks for shortlink.vue and order_confirmation.vue
      // show language prompt?
      //
      if (!this.addressName) {
        var str1 = this.$t("delivery.map-location-1");
        var str2 = this.$t("delivery.map-location-2");
        this.$swal({
          html: `${str1}<br><br>${str2}`,
          input: "text",
          inputPlaceholder: this.$t("delivery.map-location-placeholder"),
          confirmButtonText: this.$t("submit"),
          cancelButtonText: this.$t("try-again"),
          cancelButtonColor: this.bulmaColor("warning"),
          confirmButtonColor: this.bulmaColor("primary"),
          showCancelButton: true,
          inputValidator: (str) => {
            if (!str || str.length < 5)
              return "Please enter an address or street";
          },
        }).then((val) => {
          if (val.value) {
            this.addressName = val.value;
            this.fullAddress = val.value;
            this.saveAddress();
          }
        });
      } else this.saveAddress();
    },
    notifyBusiness() {
      var msg = `${this.phoneNumber} submitted their order confirmation 🙌🏽`;
      this.sendPushNotification(msg, this.createdBy);
    },
    incorrectPhoneNumber() {
      var msg = `Please tell the restaurant your correct number and they will send you a new confirmation link.`;
      this.$swal({
        type: "info",
        title: "Incorrect Mobile?",
        text: msg,
        showConfirmButton: false,
        showCloseButton: true,
      });
      //   var msg = "The customer has indicated the mobile number is incorrect.";
      //   this.sendPushNotification(msg, this.createdBy);
    },
    createStop(place) {
      return {
        id: "special_stop",
        name: place.name || place.formatted_address,
        lat: place.geometry.location.lat(),
        lon: place.geometry.location.lng(),
      };
    },

    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [],
          componentRestrictions: { country: this.country },
        }
      ); // uses all, options are ["address", "establishment", "geocode"]
      this.biasLocation(); // bias to business location initially
      this.geolocate(); // bias to user location if can get it,

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        this.console(`selected google location: ${place.name}`, place);
        this.addressName = place.name;
        this.fullAddress = place.formatted_address;
        // this.url = place.url;
        // this.place = place;
        // document.getElementById("delivery-dispatch-google").focus();

        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        this.marker.closePopup();
        this.updateMarkerLocation([lat, lng], true);
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition((position) => {
        var coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        var circle = new google.maps.Circle({
          center: coords,
          radius: position.coords.accuracy,
        });
        this.autocomplete.setBounds(circle.getBounds());
      });
    },
    // bias autocomplete to business coords
    biasLocation() {
      if (!this.businessLat) return;
      var coords = {
        lat: this.businessLat,
        lng: this.businessLon,
      };
      var circle = new google.maps.Circle({
        center: coords,
        radius: 25000, // 25 km
      });
      this.autocomplete.setBounds(circle.getBounds());
    },
    updateMarkerLocation(coords) {
      if (!this.marker || !coords) return;
      this.marker.setLatLng(coords);
      this.map.setView(coords, 17);
    },
    scrollToBottom() {
      this.submitOK = true;
      window.scrollTo(0, document.body.scrollHeight);
    },
    deliveryConfirmed() {
      var str1 = this.$t("delivery.submit-confirmed-1");
      var str2 = this.$t("delivery.submit-confirmed-2");
      var emojis = `<br><br><span style="font-size:2em">🏎 🍣 📦</span><br><br>`;
      this.$swal({
        title: this.$t("thank-you"),
        html: `${str1}${emojis}${str2} 🦜`,
        confirmButtonText: this.$t("okay"),
      }).then(() => {
        var loginMsg = `Login with this mobile: ${this.phoneNumber}`;
        if (this.loginOkay(loginMsg)) this.goHome();
        // will prompt user to login if not logged in...
        // but then need to go to another page? home?
      });
    },
    paymentQuery() {
      var query = `?price=${this.price}&payment_method=${this.paymentMethod}&created_by=${this.createdBy}&phone_number=${this.phoneNumber}&business_type=${this.businessType}&business_name=${this.businessName}&country=${this.country}`;
      if (this.paymentID) query = `${query}&payment_id=${this.paymentID}`;
      return query;
    },
    deliveryConfirmedGoToPayment() {
      // var query = `?price=${this.price}&prompt_pay=${this.promptPay}&created_by=${this.createdBy}&phone_number=${this.phoneNumber}`;

      var str1 = this.$t("delivery.submit-confirmed-1");
      var emojis = `<br><br><span style="font-size:2em">🏎 🍣 📦 🦜</span>`;
      var goto = this.$t("delivery.go-to-payment");
      this.$swal({
        title: this.$t("thank-you"),
        html: `${str1}${emojis}`,
        confirmButtonText: `${goto}&nbsp;<i class='fa fa-chevron-right'></i>`,
      }).then(() => this.goToPayment(this.paymentQuery()));
      // var loginMsg = `Login with this mobile: ${this.phoneNumber}`;
      // if (this.loginOkay(loginMsg)) this.goHome();
    },
    saveAddress() {
      //   var userID = this.phoneNumber;
      //   if (this.$store.state.user) userID = this.userID();
      // don't use user_id in case someone else is putting the address
      var data = {
        user_id: this.phoneNumber, //userID,
        name: this.addressName,
        address: this.fullAddress,
        address_type: "delivery",
        lat: this.marker.getLatLng().lat,
        lon: this.marker.getLatLng().lng,
        notes: this.notes,
      };
      this.console("saveAddress", data);
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("saveUserAddress", data)
        .then(() => {
          this.notifyBusiness();
          if (this.next) {
            this.$router.go(-1); // go back
            return;
          }
          if (this.price) this.deliveryConfirmedGoToPayment();
          else this.deliveryConfirmed();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.order-confirmation {
  height: 100vh;
  overflow: hidden;
}
.map-wrapper {
  height: calc(100vh - 335px);
  width: 100%;
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
  border: 1px solid #209cee;
  /* border-color: #209cee; */
  border-radius: 5px;
  z-index: 1;
}
.address-field {
  margin-bottom: 2px;
}
.notification {
  padding: 1rem;
}
label.label {
  margin-bottom: 0;
}
.tag {
  padding: 0 6px;
}
.tags {
  margin-bottom: 0;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
</style>

<style>
.leaflet-popup-content {
  padding: 5px 5px;
  margin: 1px 0;
  color: #209cee;
}
.leaflet-bar a,
.leaflet-bar a:hover {
  text-decoration: none !important;
}
</style>